import { IAction } from 'models';
import * as CONSTS from 'redux/constants';
import * as reduxUtil from 'redux/utils/reducers';

const stateKeys = {
  page: 'page',
  generateInner: 'generateInner',
  form: 'form'
};

const initialState = {
  [stateKeys.page]: reduxUtil.initializeObject(),
  [stateKeys.generateInner]: reduxUtil.initializeObject(),
  [stateKeys.form]: {}
};

export type IReusableLinkStore = typeof initialState;

const reducer = (state = initialState, action: IAction<string, any>) => {
  const { data, error } = action?.payload || {};

  switch (action.type) {
    case CONSTS.GET_REUSABLE_LINK_PAGE_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.page });
    case CONSTS.GET_REUSABLE_LINK_PAGE_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: stateKeys.page, data });
    case CONSTS.GET_REUSABLE_LINK_PAGE_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.page, error });
    case CONSTS.UPDATE_REUSABLE_LINK_PAGE:
      return {
        ...state,
        ...reduxUtil.updateKeyDataState({
          state,
          key: stateKeys.page,
          data: { ...(state[stateKeys.page] || ({} as any)).data, ...data }
        })
      };
    case CONSTS.RESET_GENERATE_REUSABLE_INNER_PAGE:
      return {
        ...state,
        [stateKeys.generateInner]: reduxUtil.initializeObject()
      };
    case CONSTS.GENERATE_REUSABLE_INNER_PAGE_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.generateInner });
    case CONSTS.GENERATE_REUSABLE_INNER_PAGE_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: stateKeys.generateInner, data });
    case CONSTS.GENERATE_REUSABLE_INNER_PAGE_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.generateInner, error });
    case CONSTS.SAVE_REUSABLE_FORM:
      return {
        ...state,
        ...reduxUtil.updateKeyDataState({ state, key: stateKeys.form, data })
      };
    default:
      return state;
  }
};

export default reducer;
